import { noMes } from "./util";

const AUTORIZADO = { cstat: 100, motivo: "Autorizado o uso da NF-e" };
const CANCELAMENTO = { cstat: 135, motivo: "Evento registrado e vinculado a NF-e" };

function nota(modelo, numero, status, dia, hora, dados) {
	const data = noMes(dia, hora);
	return {
		modelo,
		serie: 1,
		numero,
		status,
		id_venda: null,
		cliente: "",
		dest_cpfcnpj: "",
		data_cadastro: data,
		data_emissao: data,
		valor_total: null,
		cstat: null,
		motivo: "",
		...dados,
	};
}

export const DOCUMENTOS = [
	nota(65, 1040, "AUTORIZADA", 28, "10:42", { id_venda: 5812, valor_total: 45.9, ...AUTORIZADO }),
	nota(65, 1039, "EM_MONTAGEM", 28, "10:40", { id_venda: 5811, valor_total: 37.9, data_emissao: null }),
	nota(65, 1038, "GERADA", 28, "10:31", { id_venda: 5810, valor_total: 128.5 }),
	nota(65, 1037, "CONTINGENCIA", 27, "19:55", {
		id_venda: 5809,
		valor_total: 62,
		motivo: "Emitida offline, aguardando transmissão",
	}),
	nota(65, 1036, "AUTORIZADA", 27, "19:20", {
		id_venda: 5808,
		cliente: "Maria Aparecida Souza",
		dest_cpfcnpj: "52998224725",
		valor_total: 210.4,
		...AUTORIZADO,
	}),
	nota(65, 1035, "REJEITADA", 27, "18:02", {
		id_venda: 5807,
		valor_total: 89.9,
		cstat: 778,
		motivo: "Rejeição: Informado NCM inexistente",
	}),
	nota(55, 231, "AUTORIZADA", 27, "15:10", {
		id_venda: 5806,
		cliente: "Mercado São Jorge Ltda",
		dest_cpfcnpj: "11222333000181",
		valor_total: 1850,
		...AUTORIZADO,
	}),
	nota(65, 1034, "AUTORIZADA", 27, "12:15", { id_venda: 5805, valor_total: 33, ...AUTORIZADO }),
	nota(65, 1033, "CANCELADA", 26, "20:44", {
		id_venda: 5804,
		cliente: "João Pedro Lima",
		dest_cpfcnpj: "12345678909",
		valor_total: 150,
		...CANCELAMENTO,
	}),
	nota(65, 1032, "AUTORIZADA", 26, "20:10", { id_venda: 5803, valor_total: 72.3, ...AUTORIZADO }),
	nota(65, 1031, "ERRO", 26, "13:37", {
		id_venda: 5802,
		valor_total: 54,
		motivo: "Falha de comunicação com a SEFAZ (tempo esgotado)",
	}),
	nota(55, 230, "DENEGADA", 25, "16:22", {
		id_venda: 5801,
		cliente: "Distribuidora Alfa Ltda",
		dest_cpfcnpj: "99888777000166",
		valor_total: 3200,
		cstat: 302,
		motivo: "Uso Denegado: Irregularidade fiscal do destinatário",
	}),
	nota(65, 1029, "REJEITADA", 24, "17:48", {
		id_venda: 5799,
		valor_total: 240,
		cstat: 539,
		motivo: "Rejeição: Duplicidade de NF-e com diferença na Chave de Acesso",
	}),
	nota(65, 1028, "AUTORIZADA", 24, "09:30", { id_venda: 5798, valor_total: 98.7, ...AUTORIZADO }),
	nota(65, 1027, "AUTORIZADA", 22, "18:12", { valor_total: 15, ...AUTORIZADO }),
	nota(55, 229, "CANCELADA", 21, "14:00", {
		id_venda: 5790,
		cliente: "Mercado São Jorge Ltda",
		dest_cpfcnpj: "11222333000181",
		valor_total: 540,
		...CANCELAMENTO,
	}),
	nota(65, 1026, "CANCELADA", 20, "19:40", { id_venda: 5789, valor_total: 64.5, ...CANCELAMENTO }),
	nota(65, 1025, "AUTORIZADA", 18, "12:25", {
		id_venda: 5788,
		cliente: "Padaria Bom Gosto Ltda",
		dest_cpfcnpj: "22333444000155",
		valor_total: 120,
		...AUTORIZADO,
	}),
	nota(65, 1024, "REJEITADA", 15, "08:55", {
		id_venda: 5787,
		valor_total: 37.5,
		cstat: 704,
		motivo: "Rejeição: NFC-e com Data-Hora de emissão atrasada",
	}),
	nota(65, 1023, "AUTORIZADA", 12, "13:15", { id_venda: 5788, valor_total: 81, ...AUTORIZADO }),
	nota(55, 228, "AUTORIZADA", 10, "10:00", {
		id_venda: 5780,
		cliente: "Distribuidora Alfa Ltda",
		dest_cpfcnpj: "99888777000166",
		valor_total: 980,
		...AUTORIZADO,
	}),
	nota(65, 1022, "AUTORIZADA", 8, "19:50", { id_venda: 5779, valor_total: 55.4, ...AUTORIZADO }),
	nota(65, 1021, "AUTORIZADA", 5, "11:11", { id_venda: 5778, valor_total: 27.8, ...AUTORIZADO }),
].map((doc, i, lista) => ({ id_nota_fiscal: lista.length - i, ...doc }));

export const INUTILIZACOES = [
	nota(55, 227, "INUTILIZADA", 9, "08:30", {
		id_nota_fiscal: null,
		cstat: 102,
		motivo: "Inutilização de número homologado",
	}),
];

export function nfce(numero) {
	return DOCUMENTOS.find((doc) => doc.modelo === 65 && doc.numero === numero);
}
